(function(){
 function mv(){
  var w=document.querySelector('.Vtl-EuWithdrawalWidgetWrapper');
  var b=document.querySelector('.wawatte-footer__bottom');
  if(!w||!b||w.dataset.moved)return false;
  var box=document.createElement('div');
  box.className='wawatte-footer__withdrawal';
  w.dataset.moved='1';
  box.appendChild(w);
  b.parentNode.insertBefore(box,b);
  return true;
 }
 function prep(v){
  v.muted=true;v.defaultMuted=true;v.setAttribute('muted','');
  v.playsInline=true;v.setAttribute('playsinline','');v.setAttribute('webkit-playsinline','');
  v.loop=true;v.setAttribute('loop','');v.controls=false;v.removeAttribute('controls');
  v.preload='auto';
 }
 function load(dm){
  if(dm.getAttribute('loaded'))return dm.querySelector('video');
  var tpl=dm.querySelector('template');
  if(!tpl||!tpl.content)return null;
  var src=tpl.content.querySelector('video');
  if(!src)return null;
  var v=src.cloneNode(true);
  prep(v);
  dm.appendChild(v);
  dm.setAttribute('loaded','true');
  return v;
 }
 function play(dm){
  var v=load(dm)||dm.querySelector('video');
  if(!v)return;
  prep(v);
  var go=function(){var p=v.play();if(p&&p.catch)p.catch(function(){});};
  go();
  v.addEventListener('canplay',go,{once:true});
  v.addEventListener('loadeddata',go,{once:true});
 }
 function stop(dm){var v=dm.querySelector('video');if(v&&!v.paused)v.pause();}
 function galleryVideo(){
  var g=document.querySelector('media-gallery');
  if(!g)return;
  var list=g.querySelector('.product__media-list');
  var dms=[].slice.call(g.querySelectorAll('deferred-media'));
  if(!list)return;
  function check(){
   var lr=list.getBoundingClientRect();
   dms.forEach(function(dm){
    var s=dm.closest('.product__media-item');
    if(!s)return;
    var r=s.getBoundingClientRect();
    if(!r.width){stop(dm);return;}
    var vis=Math.min(r.right,lr.right)-Math.max(r.left,lr.left);
    if(vis/r.width>0.6)play(dm);else stop(dm);
   });
  }
  /* Fleches ordinateur : on pilote les miniatures (la galerie n'affiche qu'une image a la fois) */
  g.addEventListener('click',function(e){
   var btn=e.target.closest&&e.target.closest('.slider-button');
   if(!btn||window.innerWidth<750)return;
   var th=[].slice.call(g.querySelectorAll('.thumbnail'));
   if(th.length<2)return;
   e.preventDefault();e.stopImmediatePropagation();
   var i=0;th.forEach(function(b,k){if(b.getAttribute('aria-current')==='true')i=k;});
   var next=btn.classList.contains('slider-button--prev')?(i-1+th.length)%th.length:(i+1)%th.length;
   th[next].click();
   setTimeout(check,400);
  },true);
  var t;
  list.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(check,120);},{passive:true});
  window.addEventListener('resize',check);
  window.addEventListener('load',check);
  document.addEventListener('touchend',function(){setTimeout(check,250);},{passive:true});
  g.addEventListener('click',function(){setTimeout(check,500);});
  check();
 }
 function init(){
  if(!mv()){var n=0,t=setInterval(function(){if(mv()||++n>40)clearInterval(t)},500);}
  galleryVideo();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
